/**
 * Safe wrapper around the PostHog browser SDK loaded by /public/index.html.
 * No-ops gracefully if PostHog hasn't initialised yet (e.g., script blocked).
 */

export function track(event, properties) {
  try {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      window.posthog.capture(event, properties || {});
    }
  } catch {
    // Silent — analytics must never break the user flow
  }
}
